import "./ContactForm.scss";
import { useRef, useState } from "react";
import emailjs from "emailjs-com";
import { useTranslation } from "react-i18next";

const ContactForm = () => {
  const { t } = useTranslation();
  const form = useRef();
  const submitButton = useRef();
  const serverError = useRef();
  const loader = useRef();

  const [showToast, setShowToast] = useState(false);

  const submitForm = (e) => {
    e.preventDefault();

    serverError.current.classList.add("hidden");
    loader.current.classList.remove("hidden");
    submitButton.current.disabled = true;

    emailjs
      .sendForm(
        "service_f3uo5s9",
        "template_r2n31zt",
        form.current,
        "wAhpf-5y0-4ehsRyZ"
      )
      .then(() => {
        setShowToast(true);
        form.current.reset();
        setTimeout(() => setShowToast(false), 4000);
      })
      .catch((error) => {
        console.error("EmailJS error:", error);
        serverError.current.classList.remove("hidden");
      })
      .finally(() => {
        loader.current.classList.add("hidden");
        submitButton.current.disabled = false;
      });
  };

  const handleKeyPress = () => {
    serverError.current.classList.add("hidden");
    submitButton.current.disabled = !form.current.checkValidity();
  };

  return (
    <>
      <form className="mdl-contact-form" onSubmit={submitForm} ref={form}>
        <div className="mdl-contact-form__row mdl-contact-form__row--2col">
          <div className="mdl-contact-form__input">
            <label htmlFor="firstName">{t("firstName")} *</label>
            <input
              onKeyUp={handleKeyPress}
              required
              id="firstName"
              name="firstName"
            />
          </div>
          <div className="mdl-contact-form__input">
            <label htmlFor="lastName">{t("lastName")} *</label>
            <input
              onKeyUp={handleKeyPress}
              required
              id="lastName"
              name="lastName"
            />
          </div>
        </div>
        <div className="mdl-contact-form__row mdl-contact-form__row--2col">
          <div className="mdl-contact-form__input">
            <label htmlFor="phoneNumber">{t("yourPhone")} *</label>
            <input
              onKeyUp={handleKeyPress}
              required
              id="phoneNumber"
              name="phoneNumber"
            />
          </div>
          <div className="mdl-contact-form__input">
            <label htmlFor="email">{t("yourEmail")} *</label>
            <input
              onKeyUp={handleKeyPress}
              required
              id="email"
              name="email"
              pattern="[^@]+@[^@]+\.[a-zA-Z]{2,}"
            />
          </div>
        </div>
        <div className="mdl-contact-form__row">
          <div className="mdl-contact-form__input">
            <label htmlFor="message">{t("message")} *</label>
            <textarea
              onKeyUp={handleKeyPress}
              required
              rows={8}
              id="message"
              name="message"
            />
          </div>
        </div>

        <div
          className="mdl-contact-form__row mdl-contact-form__error hidden"
          ref={serverError}
        >
          {t("contactFormServerErrorMessage")}
        </div>

        <div className="mdl-contact-form__loader hidden" ref={loader}>
          <div className="spinner" />
        </div>

        <button type="submit" disabled ref={submitButton}>
          {t("sendMessage")}
        </button>
      </form>

      {showToast && (
        <div className="toast">{t("contactFormSuccessMessage")}</div>
      )}
    </>
  );
};

export default ContactForm;
